import Products from "./Product/Products";
import Category from "./Category/Category";
import Godown from "./Godown/Godown";
import Brands from "./Brands/Brands";
import Consumption from "./Consumption/Consumption";
import ProductIngredients from "./ProductIngredients/ProductIngredients";
export default { Products, Category, Godown, Brands, Consumption, ProductIngredients };
